const searchingalfa=[
    {
        "title":"ALL"
    },
    {
        "title":"A"
    }, {
        "title":"B"
    },{
        "title":"C"
    },
    {
        "title":"D"
    },
    {
        "title":"E"
    },
    {
        "title":"F"
    },{
        "title":"G"
    },
    {
        "title":"H"
    },
    {
        "title":"I"
    },
    {
        "title":"J"
    },
    {
        "title":"K"
    },
    {
        "title":"L"
    },
    {
        "title":"M"
    },
    {
        "title":"N"
    },
    {
        "title":"O"
    },
    {
        "title":"P"
    },
    {
        "title":"Q"
    },
    {
        "title":"R"
    },
    {
        "title":"S"
    },
    {
        "title":"T"
    },
    {
        "title":"U"
    },
    {
        "title":"V"
    },
    {
        "title":"W"
    },
    {
        "title":"X"
    },
    {
        "title":"Y"
    },
    {
        "title":"Z"
    },
]
export default searchingalfa;